// extracted by mini-css-extract-plugin
export default {"form":"styles_form__tvPHI","input-wrapper":"styles_input-wrapper__bwEzU","form-fields-row":"styles_form-fields-row__RuqJ9","captcha":"styles_captcha__fNK7u"};